
 

 

 

    import ConfigurationSearchCriteria from 'Modules/Core/Scripts/AppServiceContract/ConfigurationSearchCriteria';

    import PagingCriteria from 'Lib/Fs.Core.Data/PagingCriteria';

 
class ConfigurationSearchParameter 
{
    
        SearchCriteria: ConfigurationSearchCriteria;
    
        PagingCriteria: PagingCriteria;
    
        SortingCriteria: any;
    
}
 
export default ConfigurationSearchParameter;
 




